var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GraphicCard',{attrs:{"chart-id":"pie-projects","title":"Estado de proyectos","chart-type":"pie","label":"Identifica en qué etapa se encuentran tus proyectos","option":_vm.pieOption}})}
var staticRenderFns = []

export { render, staticRenderFns }